import api from "../services";

const draftAPI = api.injectEndpoints({
    endpoints: (builder) =>({
        getDraft : builder.query({
            query: () => ({
                url: `/api/onboardingform/hardsave/getbyid`,
                method: "GET",
              }),
        }),
        createDraft: builder.mutation({
            query: (payload) => ({
              url: `/api/onboardingform/hardsave/create`,
              method: "POST",
              body: payload,
            }),
          }),
          updateDraft: builder.mutation({
            query: (payload) => ({
              url: `/api/onboardingform/hardsave/update`,
              method: "PUT",
              body: payload,
            }),
          }),
          deleteDraft: builder.mutation({
            query: (payload) => ({
              url: `/api/onboardingform/hardsave/delete`,
              method: "DELETE",
            }),
          }),
    })
})

export default draftAPI;
export const {
    useLazyGetDraftQuery,
    useCreateDraftMutation,
    useDeleteDraftMutation,
    useUpdateDraftMutation

} = draftAPI